import { fetchJson } from '@comeon/utility';

const identify = async () => {
	if (!window.graphyte) return;

	try {
		const { result } = await fetchJson('/tracking/?frame=site');

		const { pixel_playerId: userId } = JSON.parse(result.eventInfo.replace(/'/g, '"'));

		window.graphyte.identify(userId);
	} catch {
		// just not to break anything due to operational errors
	}
};

/**
 * trackPageView
 * calls graphyte.page([category], [name], [properties], [options], [callback]);
 * All parameters are optional for graphyte:
 * category: Description of the category of the page
 * name: Page name
 * properties: A dictionary of properties of the page. url, title, referrer and path are populated automatically
 * options: Not used
 * callback: Function to call after sending the page view event
 * @param {string} path
 * @param {string} url
 * @param {string} search
 * @param {string} title
 */
const trackPageView = ({ path, url, search, title }) => {
	if (!window.graphyte) return;

	window.graphyte.page({ path, url, search, title });
};

const trackGamePlay = ({
	gameId,
	name,
	categoryCode,
	gameSessionId,
	listName,
	listGameIndex,
	locale,
	siteHostname
}) => {
	if (!window.graphyte) return;

	const localeArray = locale.split(locale.includes('_') ? '_' : '-');

	window.graphyte.track('GAME_PLAY', {
		event_type: 'gaming',
		event_uuid: window.crypto.randomUUID(), // uuid v4
		event_datetime: new Date().toISOString(),
		event_ref_id: gameSessionId, // a reference to the game session
		event_info_1: gameId, // game id (numeric)
		event_info_2: name, // game name
		event_info_3:
			categoryCode === 'CASINO_LIVE_CASINO' || categoryCode === 'LIVE_CASINO' ? 'LIVE_CASINO' : 'CASINO',
		event_language: localeArray[0],
		event_country: localeArray[1],
		event_platform: siteHostname,
		event_location: listName, // list from where the game was launched (Most Popular)
		event_location_index: listGameIndex >= 0 ? listGameIndex + 1 : undefined // 1-based index of where in the list it was placed
	});
};

export default {
	identify,
	trackPageView,
	trackGamePlay
};
